module.exports = __webpack_public_path__ + "img/KZ.0c6fa089.svg";